import React, { useState } from 'react';

const Feedback: React.FC = () => {
  const [feedbackType, setFeedbackType] = useState('feedback');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      // Send the feedback or feature suggestion to your server or API
      const response = await fetch('/api/feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ type: feedbackType, message }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit feedback');
      }

      setSubmitted(true);
    } catch (error) {
      setError('Error submitting feedback: ' + error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h1>Feedback</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            <input
              type="radio"
              value="feedback"
              checked={feedbackType === 'feedback'}
              onChange={(e) => setFeedbackType(e.target.value)}
            />
            Feedback
          </label>
          <label>
            <input
              type="radio"
              value="suggestion"
              checked={feedbackType === 'suggestion'}
              onChange={(e) => setFeedbackType(e.target.value)}
            />
            Feature Suggestion
          </label>
        </div>
        <div>
          <textarea
            placeholder="Enter your feedback or suggestion"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
      {submitted && <p>Thank you for your feedback!</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

export default Feedback;